<p-dialog [(visible)]="display" [style]="{width: '890px'}" header="{{header}}" [resizable]="false" position="top">
  <!--<h4>{{header}}</h4>-->
  <ng-container *ngIf="notification">
    <div [innerHtml]="notification['detailText']|safeHtml"></div>
  </ng-container>


  <p-footer>
    <div class="flex items-center">
      <div class="p-field-checkbox p-mb-0 p-mt-2">
        <p-checkbox [(ngModel)]="hasSeen" [ngModelOptions]="{standalone: true}" [binary]="true" inputId="hasSeen"></p-checkbox>
        <label [for]="'hasSeen'">Đánh dấu đã đọc thông báo</label>
      </div>
    </div>
<!--    <p-button *ngIf="displayUpdate" label="{{ 'Update'|translate }}" icon="pi pi-pencil" styleClass="p-button-raised p-button-warning" (onClick)="doUpdate()"></p-button>-->
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="markViewed()"></p-button>
  </p-footer>
</p-dialog>
